import { ModalHandler } from "@lib/ModalHandler";
import { TPrimaryDistCheckAnswerFlowOptions } from "@lib/types";
import { Accessor } from "solid-js";
import { getQuestionHandler } from "../form_handlers";
import { completeClrxPresets } from "./clrx";
import { completeGmPresets } from "./gm";
import { completeKcPresets } from "./kc";
import { completeLavPresets } from "./lav";
import { completePostPremierPresets } from "./post-premier";

export const GET_PRESET_OPENING_SECTION = () => [
  getQuestionHandler("radio", 1, "Did you check in with the manager before beginning your work?", "YES"),
  getQuestionHandler(
    "radio",
    1,
    /^you will be responsible for performing distribution check/i,
    "I understand what I will be responsible for"
  ),
  getQuestionHandler(
    "radio",
    2,
    /^you will be responsible for auditing/i,
    "I understand what I will be responsible for"
  ),
  getQuestionHandler("radio", 2, /are you able to begin the service/i, "Yes"),
  getQuestionHandler("radio", 3, "Are you able to begin the service?", "Yes"),
  getQuestionHandler("radio", 3, /^did you check with the manager before beginning your work/i, "YES"),
];

export const DIST_CHECK_PRIMARY_ANSWER_FLOWS: TPrimaryDistCheckAnswerFlowOptions = {
  type: "main",
  answer_flows: {
    tag_full_stock: {
      aliases: ["Confirmed in stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Fully Stocked"
        ),
      ],
    },
    tag_low_stock: {
      aliases: ["Added stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Low Stock"
        ),
        getQuestionHandler("radio", 5, "What action did you take on the item?", "Added Stock"),
      ],
    },
    tag_oos: {
      aliases: ["In-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Out of Stock"
        ),
        getQuestionHandler("radio", 5, "What action did you take on the item?", "Placed Order"),
      ],
    },
    no_tag_oos: {
      aliases: [], // oos manager refused
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Upon arrival, what is the status of the item?",
          "No Tag / Out of Stock"
        ),
        getQuestionHandler(
          "radio",
          4,
          "You have reported No Tag / Out of Stock, what action did you take?",
          "Suggested Order"
        ),
      ],
    },
    no_tag_oos_suggested_order: {
      aliases: ["Out-Of-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Upon arrival, what is the status of the item?",
          "No Tag / Out of Stock"
        ),
        getQuestionHandler(
          "radio",
          4,
          "You have reported No Tag / Out of Stock, what action did you take?",
          "Suggested Order"
        ),
      ],
    },
  },
};

// for lavazza wakefern
export const DIST_CHECK_SECONDARY_ANSWER_FLOWS: TPrimaryDistCheckAnswerFlowOptions = {
  type: "main",
  answer_flows: {
    tag_full_stock: {
      aliases: ["Confirmed in stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          2,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Fully Stocked"
        ),
      ],
    },
    tag_low_stock: {
      aliases: ["Added stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          2,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Low Stock"
        ),
        getQuestionHandler("radio", 6, "What action did you take on the item?", "Added Stock"),
      ],
    },
    tag_oos: {
      aliases: ["In-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          2,
          "Upon arrival, what is the status of the item?",
          "Tag Present / Out of Stock"
        ),
        getQuestionHandler("radio", 6, "What action did you take on the item?", "Placed Order"),
      ],
    },
    no_tag_oos: {
      aliases: [], // oos manager refused
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          2,
          "Upon arrival, what is the status of the item?",
          "No Tag / Out of Stock"
        ),
        getQuestionHandler(
          "radio",
          5,
          "You have reported No Tag / Out of Stock, what action did you take?",
          "Decision Maker Refused"
        ),
      ],
    },
    no_tag_oos_suggested_order: {
      aliases: ["Out-Of-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          2,
          "Upon arrival, what is the status of the item?",
          "No Tag / Out of Stock"
        ),
        getQuestionHandler(
          "radio",
          5,
          "You have reported No Tag / Out of Stock, what action did you take?",
          "Suggested Order"
        ),
      ],
    },
  },
};

// for clorox recovery ticket
export const DIST_CHECK_CLOROX_RECOVERY_ANSWER_FLOWS: TPrimaryDistCheckAnswerFlowOptions = {
  type: "main",
  answer_flows: {
    tag_full_stock: {
      aliases: ["Confirmed in stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Was the product on the shelf and the shelf tag present?",
          "On Shelf, Tag Present"
        ),
        getQuestionHandler(
          "radio",
          3,
          "Did you pack out this product on the shelf?",
          "No, unable to pack out product"
        ),
        getQuestionHandler(
          "radio",
          4,
          "Did you place or verify an order for this product while in store today?",
          "No order placed or verified"
        ),
        getQuestionHandler(
          "radio",
          5,
          "Did you correct product placement for this product today?",
          "Yes, corrected product placement"
        ),
      ],
    },
    tag_low_stock: {
      aliases: ["Added stock"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Was the product on the shelf and the shelf tag present?",
          "On Shelf, Tag Present"
        ),
        getQuestionHandler(
          "radio",
          3,
          "Did you pack out this product on the shelf?",
          "Yes, product packed out"
        ),
        getQuestionHandler("radio", 4, "Order placed", "No order placed or verified"),
        getQuestionHandler(
          "radio",
          5,
          "Did you correct product placement for this product today?",
          "Yes, corrected product placement"
        ),
      ],
    },
    tag_oos: {
      aliases: ["In-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Was the product on the shelf and the shelf tag present?",
          "On Shelf, Tag Present"
        ),
        getQuestionHandler(
          "radio",
          3,
          "Did you pack out this product on the shelf?",
          "Yes, product packed out"
        ),
        getQuestionHandler("radio", 4, "Order placed", "No order placed or verified"),
        getQuestionHandler(
          "radio",
          5,
          "Did you correct product placement for this product today?",
          "Yes, corrected product placement"
        ),
      ],
    },
    no_tag_oos: {
      aliases: ["Out-Of-Dist Suggested Order"], // oos manager refused
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Was the product on the shelf and the shelf tag present?",
          "Not on Shelf, Tag Missing"
        ),
        getQuestionHandler(
          "radio",
          2,
          "You reported the shelf tag was missing on arrival. Were you able to get a new one placed while in store today?",
          "No, unable to place shelf tag"
        ),
        getQuestionHandler(
          "radio",
          3,
          "Did you pack out this product on the shelf?",
          "No, unable to pack out product"
        ),
        getQuestionHandler(
          "radio",
          4,
          "Did you place or verify an order for this product while in store today?",
          "No order placed or verified"
        ),
        getQuestionHandler(
          "radio",
          5,
          "Did you correct product placement for this product today?",
          "No, placement was already correct"
        ),
      ],
    },
    no_tag_oos_suggested_order: {
      aliases: ["Out-Of-Dist Ordered"],
      get_preset_flow: () => [
        getQuestionHandler(
          "radio",
          1,
          "Was the product on the shelf and the shelf tag present?",
          "Not on Shelf, Tag Missing"
        ),
        getQuestionHandler(
          "radio",
          2,
          "You reported the shelf tag was missing on arrival. Were you able to get a new one placed while in store today?",
          "Yes, shelf tag placed "
        ),
        getQuestionHandler(
          "radio",
          3,
          "Did you pack out this product on the shelf?",
          "No, unable to pack out product"
        ),
        getQuestionHandler(
          "radio",
          4,
          "Did you place or verify an order for this product while in store today?",
          "Order placed"
        ),
        getQuestionHandler(
          "radio",
          5,
          "Did you correct product placement for this product today?",
          "Yes, corrected product placement"
        ),
      ],
    },
  },
};

export function getBackupNoTagOOSPresetFlow() {
  return getQuestionHandler(
    "radio",
    4,
    "You have reported No Tag / Out of Stock, what action did you take?",
    "Decision Maker Refused"
  );
}

export async function completeOtherPresets(
  totalStocked: number,
  clientNameLowerCase: string,
  modalHandler: Accessor<ModalHandler>
) {
  clientNameLowerCase = clientNameLowerCase.toLowerCase();

  const clientToHandler: Record<string, typeof completeLavPresets> = {
    lavazza: completeLavPresets,
    clorox: completeClrxPresets,
    "general mills": completeGmPresets,
    "kimberly clark": completeKcPresets,
    "post premier": completePostPremierPresets,
  };

  for (const [client, handler] of Object.entries(clientToHandler)) {
    if (clientNameLowerCase.includes(client)) {
      console.log(`Matched preset handler for ${client}`);

      await handler(totalStocked, modalHandler);
      return;
    }
  }
}
